export const constants = (...constants) => {
  return constants.reduce((acc, constant) => {
    acc[constant] = constant
    return acc
  }, {})
}

export const ACTION_NAMES = {
  AUTH: constants(
    "REQUEST_AUTHENTICATION",
    "REQUEST_AUTHENTICATION_ERROR",
    "RECEIVE_AUTHENTICATION",
    "LOGOUT_AUTHENTICATION",
    "REQUEST_IMPERSONATION",
    "RECEIVE_IMPERSONATION",
    "RECEIVE_IMPERSONATION_ERROR",
    "CLEAR_AUTHENTICATION_ERROR",
    "REQUEST_REMOVE_IMPERSONATION",
    "RECEIVE_REMOVE_IMPERSONATION"
  ),

  CONFIGURATION: constants(
    "UNLOAD_CONFIGURATION",
    "REQUEST_CONFIGURATION",
    "RECEIVE_CONFIGURATION"
  ),

  EMPLOYEE: constants(
    "REQUEST_EMPLOYEE",
    "RECEIVE_EMPLOYEE",
    "UNLOAD_EMPLOYEE",
    "REQUEST_CHANGE_LANGUAGE",
    "RECEIVE_CHANGE_LANGUAGE",
    "REQUEST_ACCEPT_AWARD",
    "RECEIVE_ACCEPT_AWARD",
    "RECEIVE_ACCEPT_AWARD_ERROR",
    "REQUEST_DOCUMENT",
    "RECEIVE_DOCUMENT",
    "REQUEST_CHANGE_TAX",
    "RECEIVE_CHANGE_TAX",
    "RECEIVE_CHANGE_TAX_ERROR",
    "REQUEST_CHANGE_FRACTIONAL",
    "RECEIVE_CHANGE_FRACTIONAL",
    "RECEIVE_CHANGE_FRACTIONAL_ERROR",
    "REQUEST_CHANGE_BROKER",
    "RECEIVE_CHANGE_BROKER",
    "RECEIVE_CHANGE_BROKER_ERROR",
    "REQUEST_DOWNLOAD_SUMMARY",
    "RECEIVE_DOWNLOAD_SUMMARY"
  ),

  MAINTENANCE: constants(
    'REQUEST_MAINTENANCE_STATUS',
    'RECEIVE_MAINTENANCE_STATUS'
  ),

  STATIC_CONTENT: constants(
    "UNLOAD_STATIC_CONTENT",
    "REQUEST_STATIC_CONTENT",
    "RECEIVE_STATIC_CONTENT"
  )
}
